import { mapValues } from 'lodash'
import { Dict, memoizedGet as get } from '@chakra-ui/utils'
import { WithCSSVar, useBreakpointValue } from '@chakra-ui/react'
import { HubResponsiveArray, useToken, DEFAULT_BREAKPOINT } from '../'

// TODO: what on earth is the actual type here
export const mapRules = (
  obj: Record<string, any>,
  mapper: (value: any, obj: Record<string, any>, path: string[]) => any,
  path: string[] = []
): Record<string, any> =>
  mapValues(obj, (value, key) => {
    if (value == null) {
      return value
    }
    // For media queries we recurse
    if (typeof value === 'object') {
      return mapRules(value, mapper, [...path, key])
    }
    return mapper(value, obj, [...path, key])
  })

export function useCssValueFromResponsiveProp<T extends string | number>(
  prop: HubResponsiveArray<T>,
  themeKey: string,
  defaultBreakpoint: string = DEFAULT_BREAKPOINT
): string {
  const propArray = Array.isArray(prop) ? prop : [prop]
  const propForBreakpoint: T | undefined = useBreakpointValue<T>(
    propArray as T[],
    defaultBreakpoint
  )

  const [cssValue] = useToken(
    themeKey,
    propForBreakpoint ? [propForBreakpoint] : []
  )

  return cssValue
}

// Necessary until this is implemented in ChakraUI.
// More details: https://github.com/chakra-ui/chakra-ui/issues/4055
export function getToken<T extends string | number, U extends object = Dict>(
  theme: WithCSSVar<U>,
  scale: string,
  token: T | T[],
  fallback?: T | T[]
) {
  if (Array.isArray(token)) {
    let fallbackArr: T[] = []
    if (fallback) {
      fallbackArr = Array.isArray(fallback) ? fallback : [fallback]
    }

    return token.map((token, index) => {
      const path = `${scale}.${token}`
      return get(theme, path, fallbackArr[index] ?? token)
    })
  }

  const path = `${scale}.${token}`
  return get(theme, path, fallback ?? token)
}

export { useBreakpointValue }
